module.exports = __webpack_public_path__ + "static/img/warning.0f905d43.svg";